import React from "react";

const CostTrial = ({ row }) => {
  return (
    <>
      {row.costTrial === "" ? (
        ""
      ) : (
        <div>
          <div>{row.costTrial?.cashCostTrial?.toLocaleString()}</div>
          <div>{row.costTrial?.ccCostTrial?.toLocaleString()}</div>
          <div>{row.costTrial?.eccCostTrial?.toLocaleString()}</div>
          <div>0</div>
          <div>{row.costTrial?.compCostTrial?.toLocaleString()}</div>
          <div>
            {row.costTrial?.eliteCostTrial
              ? row.costTrial?.eliteCostTrial?.toLocaleString()
              : 0}
          </div>
          <div style={{ borderTop: "1px dashed black" }}>
            <p>{row?.costTrial?.serviceCostTrialSum?.toLocaleString()}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default CostTrial;
